import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const PresetListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: flex-start;
  gap: ${pxToRem(5)};
  margin-bottom: ${pxToRem(10)};
`;

export const PresetItem = styled.button`
  background: none;
  border: none;
  display: block;
  color: #2e8ece;
  &[data-selected='true'] {
    font-weight: bold;
  }
  &:hover {
    filter: brightness(0.9);
  }
`;

export const PresetsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(10)};
`;
